import { Outlet } from "react-router-dom"

const Playlistpage = () => {
    return (
        <Outlet/>
    )
}
export default Playlistpage;